import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'envelope-status-badge',
    templateUrl: './envelope-status-badge.component.html',
    styleUrls: ['./envelope-status-badge.component.scss']
})
export class EnvelopeStatusBadgeComponent {
    @Input() document: any;

    constructor() {}
}
